var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "card-module" },
    [
      _c("div", { staticClass: "flx-between" }, [
        _c("div", { staticClass: "module-title" }, [
          _c("i", { staticClass: "el-icon-star-off" }),
          _vm._v(" " + _vm._s(_vm.$t("home.funcFavorites"))),
        ]),
        _c(
          "div",
          {
            staticClass: "point",
            on: { click: _vm.showSetFavoritesItemDialog },
          },
          [
            _c("i", {
              staticClass: "el-icon-setting",
              staticStyle: { "font-size": "25px" },
            }),
          ]
        ),
      ]),
      _c(
        "div",
        { staticClass: "button-grid" },
        _vm._l(_vm.searchMenuList, function (item, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass: "favoritesItem",
              on: {
                click: function ($event) {
                  return _vm.toMenu(item)
                },
              },
            },
            [
              _c("div", { staticClass: "favoritesName" }, [
                _vm._v(_vm._s(item.name)),
              ]),
            ]
          )
        }),
        0
      ),
      _c("favorites", {
        ref: "favoritesRef",
        attrs: {
          "pc-menu-list": _vm.menuList,
          "show-menu-list": _vm.searchMenuList,
        },
        on: { childrenSearch: _vm.childrenSearch },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }